export default {
  noticiasClientesTableHeaders: [
    {
      text: 'titulo',
      value: 'titulo',
      filterable: false,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'titulo',
      },
    },
    {
      text: 'status',
      value: 'status',
      filterable: false,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'status',
      },
    },
    {
      text: 'enviarPara',
      value: 'enviarPara',
      filterable: false,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'enviarPara',
      },
    },
    {
      text: 'dataEnvio',
      value: 'dataEnvio',
      filterable: false,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'dataEnvio',
      },
    },
    {
      text: 'horario',
      value: 'horario',
      filterable: false,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'horario',
      },
    },
    {
      text: 'acoes',
      value: 'acoes',
    },
  ],
  noticiasClientesTableItems: [],
  grupoPessoas: [],
  criarEnvioForm: {
    titulo: '',
    dataEnvio: '',
    horario: '',
    enviarPara: [],
    corpoTexto: '',
    arquivos: [],
  },
  filtros: {
    termo: '',
    page: 1,
    perPage: 20,
    order: '',
    direcao: 'DESC',
  },
};
